const initFooterAccordions = () => {
  const TABLET_BREAKPOINT = 750;
  const tabletMediaQuery = window.matchMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);
  // Force open state of footer accordions
  const footerAccordions = document.querySelectorAll('[data-footer-accordion]');
  if (footerAccordions.length < 1) return;

  const disableFooterAccordions = () => {
    footerAccordions.forEach((accordion) => {
      accordion.open = true;
      accordion.classList.add('details-accordion--disabled');
    });
  }

  const enableFooterAccordions = () => {
    footerAccordions.forEach((accordion) => {
      accordion.classList.remove('details-accordion--disabled');
    });
  }

  const updateFooterAccordions = () => {
    tabletMediaQuery.matches ? disableFooterAccordions() : enableFooterAccordions();
  }

  tabletMediaQuery.addEventListener('change', updateFooterAccordions);

  updateFooterAccordions();
}

initFooterAccordions();